import { render, staticRenderFns } from "./AppQuestionnaireResult.vue?vue&type=template&id=3703ed16&scoped=true"
import script from "./AppQuestionnaireResult.vue?vue&type=script&lang=ts"
export * from "./AppQuestionnaireResult.vue?vue&type=script&lang=ts"
import style0 from "./AppQuestionnaireResult.vue?vue&type=style&index=0&id=3703ed16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3703ed16",
  null
  
)

export default component.exports